import { Reward } from '../features/gamification';

const RewardScreen = () => {
    return <Reward />;
};
export default RewardScreen;
